<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="createForm.id?'修改代理课程' :'新增代理课程'"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          v-if="!multiple"
          label="课程选择"
          prop="courseId"
        >
          <el-select
            v-model="createForm.courseId"
            placeholder="请选择课程"
            filterable
            clearable
          >
            <el-option
              v-for="course in courseList"
              :key="course.id"
              :label="course.courseName"
              :value="course.id"
            >
              <span>{{ course.courseName }}</span>
              --
              <span :style="{color: '#ff7223'}">{{ course.coursePrice/100 }}元</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-else
          label="课程选择"
          prop="courseIds"
        >
          <el-select
            v-model="createForm.courseIds"
            placeholder="请选择课程"
            filterable
            clearable
            :multiple="multiple"
          >
            <el-option
              v-for="course in courseList"
              :key="course.id"
              :label="course.courseName"
              :value="course.id"
            >
              <span>{{ course.courseName }}</span>
              --
              <span :style="{color: '#ff7223'}">{{ course.coursePrice/100 }}元</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="课程总金额"
        >
          {{ totalPrice }}
        </el-form-item>
        <el-form-item
          label="平台分销金额"
          prop="platformDistributionAmount"
        >
          <el-input
            v-model="createForm.platformDistributionAmount"
            class="append-unit"
          >
            <template
              slot="append"
            >
              元
            </template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="老师分销金额"
          prop="teacherAmount"
        >
          <el-input
            v-model="createForm.teacherAmount"
            class="append-unit"
          >
            <template
              slot="append"
            >
              元
            </template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="代理商分销金额"
          prop="agentDistributionAmount"
        >
          <el-input
            v-model="createForm.agentDistributionAmount"
            class="append-unit"
          >
            <template
              slot="append"
            >
              元
            </template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="备注"
          prop="remark"
        >
          <el-input
            v-model="createForm.remark"
            type="textarea"
          />
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

export default {
  name: 'ProductDialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cancelText: '取消',
      courseList: [],
      createForm: {
        id: null,
        agentId: this.$route.params.id,
        courseIds: [],
        courseId: null,
        teacherAmount: 0,
        platformDistributionAmount: 0,
        agentDistributionAmount: 0,
        remark: '',
      },
      creatRules: {
        courseIds: [
          { required: true, message: '请选择代理课程', trigger: 'blur' },
        ],
        courseId: [
          { required: true, message: '请选择代理课程', trigger: 'blur' },
        ],
        platformDistributionAmount: [
          {
            required: true, message: '请输入平台分销金额', trigger: 'blur',
          },
        ],
        teacherAmount: [
          {
            required: true, message: '请输入老师分销金额', trigger: 'blur',
          },
        ],
        agentDistributionAmount: [
          {
            required: true, message: '请输入代理商分销金额', trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    totalPrice() {
      console.log(this.multiple);
      const id = this.multiple && this.createForm.courseIds ? this.createForm.courseIds[0] : this.createForm.courseId;
      if (id) {
        if (this.courseList.filter((v) => v.id === id).length > 0) {
          return `${this.courseList.filter((v) => v.id === id)[0].coursePrice / 100}元`;
        }
      }
      return '0元';
    },
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            if (this.item) {
              const {
                id,
                courseId,
                courseIds,
                platformDistributionAmount,
                teacherAmount,
                agentDistributionAmount,
                remark,
              } = this.item;
              this.createForm = {
                id,
                agentId: this.$route.params.id,
                courseId,
                courseIds,
                platformDistributionAmount: platformDistributionAmount ? platformDistributionAmount / 100 : 0,
                teacherAmount: teacherAmount ? teacherAmount / 100 : 0,
                agentDistributionAmount: agentDistributionAmount ? agentDistributionAmount / 100 : 0,
                remark,
              };
            } else {
              this.createForm.id = null;
            }
          });
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getCourseList();
  },
  methods: {
    close() {
      this.$refs.createForm.clearValidate();
      this.$refs.createForm.resetFields();
      this.$emit('update:dialogVisible', false);
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          this.createForm.platformDistributionAmount *= 100;
          this.createForm.teacherAmount *= 100;
          this.createForm.agentDistributionAmount *= 100;
          let data;
          if (!this.multiple) {
            data = await axClient.agent.agentCourseUpsert(this.createForm);
          } else if (this.item) {
            data = await axClient.agent.updateBatch(this.createForm);
          } else {
            data = await axClient.agent.insertBatch(this.createForm);
          }
          if (!data) return;
          this.$message.success('编辑代理商课程成功');
          this.close();
          this.$emit('confirm');
        }
      });
      this.close();
    },
    // 查询课程列表
    async getCourseList() {
      this.courseList = await axClient.cert.listCourseNameByCert();
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  ::v-deep .main-color{
    color: $--base-color-main;
  }
}

</style>
